<template>
  <div class="com-container">
    <div class="toolbar">
      <h2>
        <em></em>
        <span>{{$t("changePwd.title")}}</span>
      </h2>
    </div>
    <div class="cp-container">
      <section>
        <el-form :model="chgPwdForm" status-icon :rules="chgPwdRule" ref="chgPwdForm" label-width="170px">
          <el-form-item :label="$t('changePwd.oldPassword')" prop="oldPass">
            <el-input type="password" v-model="chgPwdForm.oldPass" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
          </el-form-item>
          <el-form-item :label="$t('changePwd.newPassword')" prop="newPass">
            <el-input type="password" v-model="chgPwdForm.newPass" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
          </el-form-item>
          <el-form-item :label="$t('changePwd.retypePassword')" prop="checkPass">
            <el-input type="password" v-model="chgPwdForm.checkPass" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
            <el-button type class="cp-Btn" @click="submitForm">{{$t("common.submit")}}</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
  </div>
</template>
<script>
import { changePassword } from "../../request";
import { pattern } from "../../../server/common/data";

export default {
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('changePwd.oldPwdRequried')));
      } else {
        if (pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.passwordFormat')));
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('changePwd.newPwdRequried')));
      } else {
        if (pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.passwordFormat')));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('changePwd.confirmNewPwd')));
      } else if (value !== this.chgPwdForm.newPass) {
        callback(new Error(this.$t('changePwd.confirmNewPwdMismatch')));
      } else {
        callback();
      }
    };
    return {
      chgPwdForm: {
        oldPass: "",
        newPass: "",
        checkPass: ""
      },
      chgPwdRule: {
        oldPass: [{ validator: validateOldPass, trigger: "blur" }],
        newPass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.chgPwdForm.validate(valid => {
        if (valid) {
          let data = {
            password_old: this.chgPwdForm.oldPass,
            password_new: this.chgPwdForm.newPass
          };
          changePassword(this, data);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cp-container {
  width: 94%;
  margin: 80px 2% 0;
  .el-input__inner {
    width: 410px;
    height: 40px;
    border-radius: 4px;
    border: solid 1px #d2dcef;
  }
  .el-input-group {
    width: 550px;
  }
  .el-button el-button--default {
    width: 110px !important;
    height: 40px;
    border: none;
    margin: 0;
    padding: 0;
    text-align: center;
    border-radius: 2px;
  }
  .el-input-group__append .el-button,
  .el-input-group__append .el-select,
  .el-input-group__prepend .el-button,
  .el-input-group__prepend .el-select {
    margin: 0;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    width: 110px;
    height: 40px;
    border: none;
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    border-radius: 2px;
  }
  .el-form-item__label {
    text-align: left;
  }
  .cp-Btn {
    width: 110px;
    height: 40px;
    color: #fff;
    border: none;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
    background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?78e5f159